import { useIntl } from 'react-intl';
import { useState } from 'react';
import { StyledClassifiersButtons, StyledClassifiersTab } from './style';
import { Button, Table } from 'ui';
import { Classifier } from 'types/Classifier';
import dayjs from 'dayjs';
import EditClassifiers from './EditClassifiers';

const ClassifiersTab = () => {
  const intl = useIntl();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [classifierIdToEdit, setClassifierIdToEdit] = useState<number>();
  const [reload, setReload] = useState<number>(0);

  const handleEdit = (id: number) => {
    setIsDrawerOpen(true);
    setClassifierIdToEdit(id);
  };

  const closeDrawer = () => {
    setClassifierIdToEdit(undefined);
    setIsDrawerOpen(false);
  };

  const columns = [
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'name',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'classifiers.updated_at' }),
      dataIndex: 'updated_at',
      render: (value: string) => dayjs(value).format('DD.MM.YYYY'),
    },
    {
      title: intl.formatMessage({ id: 'classifiers.version' }),
      dataIndex: 'version',
      render: (value: number) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.actions' }),
      render: (record: Classifier) => (
        <StyledClassifiersButtons>
          <Button
            type="primary"
            label={intl.formatMessage({ id: 'general.edit' })}
            onClick={() => handleEdit(record.id)}
          />
        </StyledClassifiersButtons>
      ),
    },
  ];

  return (
    <StyledClassifiersTab>
      <Table columns={columns} url={'/api/v2/classifiers'} reload={reload} />
      {classifierIdToEdit && (
        <EditClassifiers
          setReload={setReload}
          classifierIdToEdit={classifierIdToEdit}
          isDrawerOpen={isDrawerOpen}
          closeDrawer={closeDrawer}
        />
      )}
    </StyledClassifiersTab>
  );
};

export default ClassifiersTab;
